"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ItemButtons = void 0;
var _components = require("@ori-ui/components");
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
var _favoritesHeart = require("@ori/favorites-heart");
var _context = require("../../context");
var _jsxRuntime = require("react/jsx-runtime");
/* eslint-disable complexity -- many options :( */

const ItemButtons = () => {
  const {
    buttons,
    code,
    itemTestId
  } = (0, _context.useItemContext)();
  const {
    delayBackorder,
    favorites,
    notifyMe,
    postpone,
    remove,
    replace,
    repurchase,
    reserve,
    subscribe,
    unreserve
  } = buttons ?? {};
  const buttonList = [replace ? {
    ...replace,
    key: 'replace'
  } : undefined, reserve ? {
    ...reserve,
    key: 'reserve'
  } : undefined, unreserve ? {
    ...unreserve,
    key: 'unreserve'
  } : undefined, delayBackorder ? {
    ...delayBackorder,
    key: 'delayBackorder'
  } : undefined, subscribe ? {
    ...subscribe,
    key: 'subscribe'
  } : undefined, postpone ? {
    ...postpone,
    key: 'postpone'
  } : undefined];
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [remove?.visible ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.IconButton, {
      disabled: remove.disabled ?? false,
      "data-testid": `${itemTestId}-remove`,
      variant: "contained",
      color: "default",
      hoverIcon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.TrashcanFilled, {}),
      "aria-label": remove.title,
      onClick: remove.onClick ?? undefined,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.Trashcan, {})
    }) : null, repurchase?.visible ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.IconButton, {
      disabled: repurchase.disabled ?? false,
      "data-testid": `${itemTestId}-repurchase`,
      variant: "contained",
      color: "default",
      hoverIcon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.AddToBagFilled, {}),
      "aria-label": repurchase.title,
      onClick: repurchase.onClick ?? undefined,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.AddToBag, {})
    }) : null, favorites?.visible ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_favoritesHeart.FavoritesHeartIconButton, {
      disabled: favorites.disabled ?? false,
      code: code,
      size: "medium",
      "aria-label": favorites.title,
      "data-testid": `${itemTestId}-favorites`
    }) : null, notifyMe?.visible ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.IconButton, {
      disabled: notifyMe.disabled ?? false,
      "data-testid": `${itemTestId}-notify`,
      variant: "contained",
      color: "default",
      hoverIcon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.NotificationFilled, {}),
      "aria-label": notifyMe.title,
      onClick: notifyMe.onClick ?? undefined,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.Notification, {})
    }) : null, buttonList.map(button => button?.visible ? button.disabled ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Tooltip, {
      disableFocusListener: true,
      title: button.title,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Button, {
          disabled: true,
          "data-testid": `${itemTestId}-${button.key}`,
          variant: "contained",
          color: "primary",
          size: "small",
          "aria-label": button.title,
          onClick: undefined,
          children: button.text
        })
      })
    }, button.key) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Button, {
      "data-testid": `${itemTestId}-${button.key}`,
      variant: "contained",
      color: "default",
      size: "small",
      "aria-label": button.title,
      onClick: button.onClick ?? undefined,
      children: button.text
    }, button.key) : null)]
  });
};
exports.ItemButtons = ItemButtons;
